const exampleConfig = {
    word: {
        filterLayout: 'ExampleFilterDefaultLayout',
        listLayout: 'ExampleListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getExample',
        listApiParamSet: {
            ip: 1,
        },
        paginationType: 'pagination',
        deleteFunc: 'deleteExample',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteSuccessMsg: '삭제가 완료되었습니다.',
        listFailMsg: '데이터를 불러올 수 없습니다.',
        deleteFailMsg: '삭제에 실패하였습니다.',
        keyName: 'ek_idxs',
    },
    writeWord: {
        writeLayouts: ['ExampleWriteDefaultLayout'],
        writeFunc: 'writeExample',
        writeApiParamSet: {},
        parsingData: {
            sentence: 'ek_sentence',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
    },
    updateExample: {
        writeLayouts: ['ExampleWriteDefaultLayout'],
        getFunc: 'getExample',
        detailApiParamSet: {
        },
        writeFunc: 'updateExample',
        writeApiParamSet: {},
        parsingData: {
            sentence: 'ek_sentence',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        keyName: 'ek_idx',
        deleteFunc: 'deleteExample',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteSuccessMsg: '삭제가 완료되었습니다.',
        deleteFailMsg: '삭제에 실패하였습니다.',
        deleteKeyName: 'ek_idxs',
    },
}
export default {
    methods: {
        returnExampleConfig(type) {
            return exampleConfig[type];
        }
    },
    filterConfig: {
        ek_sentence: { // 제목
            type: 'query',
            classname: 'searchInput'
        },
        cr:{ // 시작일
            type: 'between',
            classname: 'filterDate'
        },

    }
}
